import AssistantBack from './AssistantBack';
export default AssistantBack;
